import "react-app-polyfill/ie9";
import "react-app-polyfill/ie11";
import "react-app-polyfill/stable";
import React from "react";
import UploadFiles from "./UploadFiles/UploadFiles";
import Introduction from "./Introduction/Introduction";
import DetailedView from "./DetailedView/DetailedView";
import FilesList from "./DetailedView/FilesList";
import { arrayMove } from "react-sortable-hoc";
import MapDisplay from "./Maps/Maps";
import Analysis from "./Analysis/Analysis";
import "./App.css";
import Snackbar from "@material-ui/core/Snackbar";

import {
  deleteBorehole,
  patchSridToProject,
  updateSoilprofile,
} from "./api/PostBorehole";

import { Alert } from "./DetailedView/FilesList";

class App extends React.Component {
  constructor(props) {
    super(props);

    this.defaultParams = {
      writeWhere: "top",
      convertLayersStandard: false,
    };


    this.state = {
      token: props.token,
      srid: props.srid,
      project_id: props.project_id,
      boreholeList: props.boreholeList,
      toggleOpen: true,
      analysisActiveIds: [],
      checkedFiles: [],
      allChecked: false,
      detailedViewId: "",
      coordinates: [],
      loading: false,
      updateAnalysisId: "",
      updateDetailedView: false,
      writeWhere: this.defaultParams.writeWhere,
      convertLayersStandard: this.defaultParams.convertLayersStandard,
      crs: props.crs,
      currentCoordinateSystem: props.currentCoordinateSystem,

      colorConfig: {
        Kvikkleire: "#EB4036",
        Leire: "#EBE25B",
        "Tørrskorpe leire": "#87241F",
        Silt: "#FFCB57",
        Sand: "#4E9937",
        Friksjonsjord: "#5BA1C2",
        Stein: "#787169",
        Morene: "#787169",
        "Harde masser": "#787169",
        Berg: "#292624",
        Drenert: "#6CCF50",
        Udrenert: "#EBE25B",
      },
    };
  }

  saveState = () => {
    console.log("save only the checked files data when hit on button ");
    console.log(this.state.checkedFiles);
    // set("state", JSON.stringify(this.state));
  };

  loadState = () => {
    // this.setState({ currentCoordinateSystem: this.state.crs.find(crs=>crs.srid===this.props.srid) });
    // get("state").then((state) => {
    //   state = state ? JSON.parse(state) : null;
    //   if (state && Object.entries(state).length !== 0) {
    //     state.loading = false;
    //     this.setState(state);
    //   }
    // })
  };

  componentDidMount = () => {
    // this.setState( {boreholeList:fetchBoreholeList()})

    // fetch("http://127.0.0.1:8000/projects/a71be49a-82f6-4d32-9182-684dc9399a96/boreholes").then(data=>{
    //     return data.json()
    // }).then(data=>{
    //     Object.keys(data).forEach(function(key, index) {
    //         let selectedFiles=data[key]
    //     })
    //     return (this.setState({boreholeList:data}))})
    document.title = "Geotolk";
    this.loadState();
  };

  componentDidUpdate = (prevProps) => {
    if (this.props.boreholeList !== prevProps.boreholeList) {
      this.setState({
        token: this.props.token,
        srid: this.props.srid,
        project_id: this.props.project_id,
        boreholeList: this.props.boreholeList,
        toggleOpen: true,
        analysisActiveIds: [],
        checkedFiles: [],
        allChecked: false,
        detailedViewId: "",
        coordinates: [],
        loading: false,
        updateAnalysisId: "",
        updateDetailedView: false,
        writeWhere: this.defaultParams.writeWhere,
        convertLayersStandard: this.defaultParams.convertLayersStandard,

        snackbarOpen: false,
        snackbarMessage: "",
        snackbarSeverity: "success",
      });
    }
  };

  handleStagedForAnalysisChange = (newStagedForAnalysis) => {
    this.setState({ stagedForAnalysis: newStagedForAnalysis });
  };

  handleUploadFile = (boreholeList) => {
    this.setState({ boreholeList: boreholeList });
  };

  handleBorholeChange = (
    boreholeList,
    updataAnalysisId,
    updateDetailedView
  ) => {
    this.setState({
      boreholeList: boreholeList,
      updateAnalysisId: updataAnalysisId,
      updateDetailedView: updateDetailedView,
    });
  };

  handleCoordinateSystemChange = (newCoordinateSystem) => {
    console.log(newCoordinateSystem);
    this.setState({ currentCoordinateSystem: newCoordinateSystem });
  };

  handleCoordinatesChange = (newCoordinates) => {
    this.setState({ coordinates: newCoordinates });
  };

  handleLoadingChange = (newLoading) => {
    this.setState({ loading: newLoading });
  };

  handleAnalysisChange = (newActiveBorholes) => {
    this.setState({ analysisActiveIds: newActiveBorholes });
  };

  handleDetailedViewChange = (id) => {
    this.setState({ detailedViewId: id });
  };

  handleSetSidebarOpen = (value) => {
    this.setState({ sidebarOpen: value });
  };

  handleListToggle = (value) => {
    this.setState({ toggleOpen: value });
  };

  handleUpdateAnalysisIdChange = (id) => {
    this.setState({ updateAnalysisId: id });
  };

  handleUpdateDetailedViewChange = (bool) => {
    this.setState({ updateDetailedView: bool });
  };

  changeAnalysisActiveIdsOrder = (oldIndex, newIndex) => {
    this.setState({
      analysisActiveIds: arrayMove(
        this.state.analysisActiveIds,
        oldIndex,
        newIndex
      ),
    });
  };

  handleCheck = (e, fileId) => {
    this.setState((state) => ({
      checkedFiles: state.checkedFiles.includes(fileId)
        ? state.checkedFiles.filter((c) => c !== fileId)
        : [...state.checkedFiles, fileId],
    }));
  };

  handleCheckAll = (e) => {
    let allChecked = this.state.allChecked;
    if (allChecked) {
      this.setState({ checkedFiles: [], allChecked: false });
    } else {
      this.setState({
        checkedFiles: Object.keys(this.state.boreholeList),
        allChecked: true,
      });
    }
  };

  handleSnackbarClose = () => {
    this.setState({ snackbarOpen: false });
  };

  handleSridToProject = async () => {
    try {
      await patchSridToProject(
        this.state.project_id,
        this.state.currentCoordinateSystem.srid,
        this.state.token
      );
      this.setState({
        snackbarMessage: `Success changed coordinate system to ${this.state.currentCoordinateSystem.srid}`,
        snackbarSeverity: "success",
        snackbarOpen: true,
      });
    } catch (error) {
      console.log(error);
      this.setState({
        snackbarMessage: error.message,
        snackbarSeverity: "error",
        snackbarOpen: true,
      });
    }
  };

  handleDelete = async () => {
    let checkedFiles = this.state.checkedFiles;
    let boreholeList = this.state.boreholeList;
    let detailedViewId = this.state.detailedViewId;
    let analysisActiveIds = this.state.analysisActiveIds;
    checkedFiles.forEach(async (checkedFileId) => {
      try {
        await deleteBorehole(
          this.state.project_id,
          checkedFileId,
          this.state.token
        );
        delete boreholeList[checkedFileId];

        if (checkedFileId === detailedViewId) {
          detailedViewId = "";
        }

        let analysisActiveIdsIndex = analysisActiveIds.findIndex(
          (id) => id === checkedFileId
        );

        if (analysisActiveIdsIndex !== -1) {
          analysisActiveIds.splice(analysisActiveIdsIndex, 1);
        }

        this.setState({
          snackbarMessage: `Success ${checkedFiles.length} files saved`,
          snackbarSeverity: "success",
          snackbarOpen: true,
        });
      } catch (error) {
        this.setState({
          snackbarMessage: error.message,
          snackbarSeverity: "error",
          snackbarOpen: true,
        });
      }

      // try {
      //   deleteBorehole(this.project_id,location_id=checkedFileId)
      // } catch (error) {
      //     throw new Error(error)
      // }
    });

    this.setState({
      boreholeList: boreholeList,
      checkedFiles: analysisActiveIds,
      analysisActiveIds: analysisActiveIds,
      detailedViewId: detailedViewId,
    });
  };

  onWriteWhereChange = (e) => {
    this.setState({ writeWhere: e.target.value });
  };

  onConvertLayersChange = (e) => {
    this.setState({ convertLayersStandard: !this.state.convertLayersStandard });
  };

  handleQuickClay = async () => {
    console.log(this.state.checkedFiles);
    if (!this.state.checkedFiles) {
      return;
    }
    const filesToSave = Object.values(this.state.boreholeList).filter(
      (borehole) => this.state.checkedFiles.includes(borehole.id)
    );
    const token = this.state.token;
    filesToSave.forEach(async (borehole) => {
      const location_id = borehole.id;
      const tlk = borehole.DYNAMIC_DATA.slice(0, -1).map((item) => {
        if (
          (item.type === "Leire" ||
            item.type === "Udrenert" ||
            item.type === "silt") &&
          item.probability > 0.6
        ) {
          return { ...item, type: "Kvikkleire" };
        }
        return item;
      });
      try {
        const response = await updateSoilprofile(
          this.state.project_id,
          location_id,
          tlk,
          token
        );
        this.setState({
          snackbarMessage: `Success ${this.state.checkedFiles.length} files added quickclay, rerender/refresh to see change`,
          snackbarSeverity: "success",
          snackbarOpen: true,
        });
      } catch (error) {
        this.setState({
          snackbarMessage: error.message,
          snackbarSeverity: "error",
          snackbarOpen: true,
        });
      }
    });
  };

  handle3D = async () => {
    if (!this.state.checkedFiles) {
      return;
    }
    
    const filesToSave = Object.values(this.state.boreholeList).filter(
      (borehole) => this.state.checkedFiles.includes(borehole.id)
    );
    
    const boreholeIds = filesToSave.map((borehole) => borehole.id);
  
    // Specify the dimensions of the new window
    const windowWidth = 1000; // Adjust as needed
    const windowHeight = 1000; // Adjust as needed
  
    const newWindow = window.open(
      `/ifc?ids=${boreholeIds}`,
      '_blank',
      `width=${windowWidth},height=${windowHeight}`
    );
  
    // Check if the window was successfully opened
    if (!newWindow) {
      console.error('Failed to open new window.');
      return;
    }
  };

  // try {
  //   const response = await updateSoilprofile(this.state.project_id, location_id, tlk, token);
  //   this.setState({
  //     snackbarMessage: `Success ${this.state.checkedFiles.length} files added quickclay, rerender/refresh to see change`,
  //     snackbarSeverity: "success",
  //     snackbarOpen: true,
  //   });
  // } catch (error) {
  //   this.setState({
  //     snackbarMessage: error.message,
  //     snackbarSeverity: "error",
  //     snackbarOpen: true,
  //   });
  // }

  render() {
    const boreholeList = this.state.boreholeList || [];
    const currentCoordinateSystem = this.state.currentCoordinateSystem;
    const loading = this.state.loading;

    const analysisActiveIds = this.state.analysisActiveIds;
    const updateAnalysisId = this.state.updateAnalysisId;

    const updateDetailedView = this.state.updateDetailedView;
    const detailedViewId = this.state.detailedViewId;

    const colorConfig = this.state.colorConfig;

    if (this.props.accountInfo) {
      return (
        <div className="App">
          <FilesList
            project_id={this.state.project_id}
            token={this.state.token}
            accountInfo={this.props.accountInfo}
            boreholeList={boreholeList}
            updateAnalysis={this.handleAnalysisChange}
            updateDetailedView={this.handleDetailedViewChange}
            loading={loading}
            onLoadingChange={this.handleLoadingChange}
            checkedFiles={this.state.checkedFiles}
            allChecked={this.state.allChecked}
            handleCheck={this.handleCheck}
            handleCheckAll={this.handleCheckAll}
            handleListToggle={this.handleListToggle}
            toggleOpen={this.state.toggleOpen}
            writeWhere={this.state.writeWhere}
            onWriteWhereChange={this.onWriteWhereChange}
            convertLayersStandard={this.state.convertLayersStandard}
            handleDelete={this.handleDelete}
          />
          <div className="content-container">
            <div className="step-one">
              <div className="step-one-content">
                <span style={{ marginTop: "50px" }}>
                  <Snackbar
                    open={this.state.snackbarOpen}
                    autoHideDuration={3000}
                    onClose={this.handleSnackbarClose}
                    anchorOrigin={{ vertical: "top", horizontal: "middle" }}
                  >
                    <Alert
                      onClose={this.handleSnackbarClose}
                      severity={this.state.snackbarSeverity}
                    >
                      {this.state.snackbarMessage}
                    </Alert>
                  </Snackbar>
                </span>
                <Introduction />
                <UploadFiles
                  token={this.state.token}
                  project_id={this.state.project_id}
                  accountInfo={this.props.accountInfo}
                  boreholeList={boreholeList}
                  onUploadFile={this.handleUploadFile}
                  loading={loading}
                  onLoadingChange={this.handleLoadingChange}
                  colorConfig={colorConfig}
                  writeWhere={this.state.writeWhere}
                  onWriteWhereChange={this.onWriteWhereChange}
                  convertLayersStandard={this.state.convertLayersStandard}
                  onConvertLayersChange={this.onConvertLayersChange}
                  srid={this.state.srid}
                  choosen_crs={this.state.currentCoordinateSystem.srid}
                />
              </div>
            </div>

            <DetailedView
              detailedViewId={detailedViewId}
              updateDetailedView={updateDetailedView}
              setUpdateDetailedView={this.handleUpdateDetailedViewChange}
              accountInfo={this.props.accountInfo}
              boreholeList={boreholeList}
              borehole={boreholeList[this.state.detailedViewId]}
              onDeleteEntry={this.handleDeleteEntry}
              loading={loading}
              onLoadingChange={this.handleLoadingChange}
              colorConfig={colorConfig}
              onDynamicDataChange={this.handleBorholeChange}
              toggleOpen={this.state.toggleOpen}
            />

            <Analysis
              detailedViewId={detailedViewId}
              updateAnalysisId={updateAnalysisId}
              setUpdateAnalysisId={this.handleUpdateAnalysisIdChange}
              accountInfo={this.props.accountInfo}
              boreholeList={boreholeList}
              onDynamicDataChange={this.handleBorholeChange}
              analysisActiveIds={analysisActiveIds}
              changeAnalysisActiveIdsOrder={this.changeAnalysisActiveIdsOrder}
              updateDetailedView={this.handleDetailedViewChange}
              loading={loading}
              onLoadingChange={this.handleLoadingChange}
              colorConfig={colorConfig}
              handleQuickClay={this.handleQuickClay}
              handle3D={this.handle3D}
            />

            <MapDisplay
              boreholeList={boreholeList}
              loading={loading}
              onLoadingChange={this.handleLoadingChange}
              updateDetailedView={this.handleDetailedViewChange}
              checkedFiles={this.state.checkedFiles}
              handleCheck={this.handleCheck}
              currentCoordinateSystem={currentCoordinateSystem}
              onCoordinateSystemChange={this.handleCoordinateSystemChange}
              onCoordinatesChange={this.handleCoordinatesChange}
              toggleOpen={this.state.toggleOpen}
              handleSridToProject={this.handleSridToProject}
              srid={this.state.srid}
              crs={this.state.crs}
              choosen_crs={this.state.choosen_crs}
              postSridToProject={this.handleSridToProject}
            />
          </div>
        </div>
      );
    } else {
      //Return empty because there are some lag when logging in/out
      return <div />;
    }
  }
}

export default App;
